import styled from 'styled-components'

export default styled.div`
  -ms-flex: 1 1 0%;
`
